



	// @ts-ignore
    import _ from './ProcedureShareMailAuth.ts'; export default _;
